// extracted by mini-css-extract-plugin
module.exports = {"defaultImg":"defaultImg___2boAX"};